import React from 'react';
import mustache from 'mustache';
import { useTranslations } from '../../hooks/useTranslations';
import styles from './TrackPageTitle.module.css';

export const TrackPageTitle = () => {
  const { trackPageTitle, trackingStatus } = useTranslations();

  return (
    <div className={styles.container}>
      <h1>
        {mustache.render(trackPageTitle ?? '', {
          statusText: trackingStatus,
        })}
      </h1>
    </div>
  );
};

export default TrackPageTitle;
